import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {GruppeModell, Gruppetype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {medlemmerMedTilgangMedBrukertilknytning, medlemmerMedTilgangUtenBrukertilknytning} from "felles-ng2/modell/medlemModellHjelpere";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {MatButton} from "@angular/material/button";
import {GruppeLogoKomponent} from "../gruppe-logo/gruppe-logo";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MatTooltip} from "@angular/material/tooltip";


const debug = initDebugger('GruppeKortKomponent');

@Component({
    selector: 'gruppe-kort',
    templateUrl: 'gruppe-kort.html',
    styleUrl: 'gruppe-kort.scss',
    host: { 'data-testid': 'gruppe' },
    imports: [
        MatButton,
        MatIcon,
        TranslateModule,
        KortKomponent,
        KortHandlingerKomponent,
        GruppeLogoKomponent,
        MatTooltip
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeKortKomponent {

    gruppe = input.required<GruppeModell>();

    erMalgruppe = computed(()=>this.gruppe().gruppetype == Gruppetype.mal);
    antallMedlemmer = computed(() => medlemmerMedTilgangMedBrukertilknytning(this.gruppe().alleMedlemmer).length);
    antallInviterte = computed(() => medlemmerMedTilgangUtenBrukertilknytning(this.gruppe().alleMedlemmer).length);
    harTilgang = computed(() => this.kontekst.autentisertBruker().harTilgangTilGruppe(this.gruppe().id));
    aarstall: number;

    constructor(private navigasjon: Navigasjon, private klokke: Klokke, private kontekst:BrukerkontekstTilbyder) {
        this.aarstall = this.klokke.nåSomPlainDate().year;
    }

    gaaTilGruppe() {
        this.navigasjon.gåTilGruppe(this.gruppe().id);
    }
}

